import React from "react";
import { Steps } from "antd";
import { useTranslation } from "react-i18next";

import "@/components/dashboard/misc/StepOperation.less";

const { Step } = Steps;

const StepOperation = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Steps status="wait" direction="vertical" className="operation-step">
        <Step title={t('step.title1')} description={t('step.desc1')} />
        <Step title={t('step.title2')} description={t('step.desc2')} />
        <Step title={t('step.title3')} description={t('step.desc3')} />
        <Step title={t('step.title4')} description={t('step.desc4')} />
      </Steps>
    </div>
  );
};

export default StepOperation;
